import React from 'react'
import { ImageNames, svgImageNames } from 'src/enums'
import {
  useColorOrGrayscaleImage,
  useColorOrGrayscaleSVG,
} from 'src/hooks/brandHooks'
import { css } from 'styled-components'

interface NoAccountActivityProps {
  titleText: React.ReactNode
  subtitleText?: React.ReactElement
  budgetAccount: boolean
}

const NoAccountActivity: React.FC<NoAccountActivityProps> = (props) => {
  const budgetAccountImage = props.budgetAccount
    ? useColorOrGrayscaleSVG(svgImageNames.NoAccountsOrBudgets)
    : useColorOrGrayscaleImage(ImageNames.NoVirtualCards)
  return (
    <div
      css={css`
        width: 40%;
        max-width: 400px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-self: center;
        align-items: center;
        margin-top: 40px;
        margin-bottom: 20px;
      `}
    >
      <div
        css={css`
          margin-bottom: 40px;
        `}
      >
        {budgetAccountImage}
      </div>
      <span
        css={css`
          font-weight: bold;
          margin-bottom: 20px;
        `}
      >
        {props.titleText}
      </span>
      {props.subtitleText && (
        <>
          <span
            css={css`
              margin-bottom: 20px;
            `}
          >
            {props.subtitleText}
          </span>
        </>
      )}
    </div>
  )
}

export default NoAccountActivity
